import { PHONE_REGEXP } from '@/constants/RegExpConstants';

export default {
  methods: {
    /**
     * Returns the formatted input phone number for 10 digits and 11 digits
     * @param {*} inputPhoneNumber
     */
    formatPhoneNumber(inputPhoneNumber) {
      let phoneNumber = inputPhoneNumber;
      phoneNumber = phoneNumber.replace(RegExp(PHONE_REGEXP.FILTER_NUMBERS), '');
      if (phoneNumber.length === 10) {
        const m = RegExp(PHONE_REGEXP.US_10DIGITS).exec(phoneNumber);
        if (m != null) {
          phoneNumber = !m ? null : `(${m[1]}) ${m[2]}-${m[3]}`;
        }
      } else if (phoneNumber.length === 11) {
        const m = RegExp(PHONE_REGEXP.US_11DIGITS).exec(phoneNumber);
        if (m != null) {
          phoneNumber = !m ? null : `(${m[1]}) ${m[2]}-${m[3]}`;
        }
      }
      return phoneNumber;
    },
  },
};
